


























































































































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { ContractRenewalStateEnum, IContract } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';
import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';

import ALDialog from '@/components/core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components//common/ErrorAlert.vue';

enum ContractRenewalStepEnum {
  RenewalConfirm,
  ChangesConfirm,
  QRFAttachmentConfirm
}
export default mixins(auth, snackbar).extend({
  name: 'ContractRenewStateButton',

  components: {
    ALDialog,
    ErrorAlert
  },

  props: {
    contract: {
      type: Object as PropType<IContract>
    }
  },

  data() {
    return {
      error: null as ISystemError | null,

      isLoading: false,

      isDialogActive: false,

      ContractRenewalStepEnum: ContractRenewalStepEnum,
      wizardStep: ContractRenewalStepEnum.RenewalConfirm
    };
  },

  computed: {
    title(): string {
      switch (this.wizardStep) {
        case ContractRenewalStepEnum.RenewalConfirm:
          return 'Confirm Renewal';
        case ContractRenewalStepEnum.ChangesConfirm:
          return 'Contract Changes';
        case ContractRenewalStepEnum.QRFAttachmentConfirm:
          return 'QRF submission confirmation';
        default:
          return '';
      }
    },

    subtitle(): string {
      switch (this.wizardStep) {
        case ContractRenewalStepEnum.RenewalConfirm:
          return 'Is this contract being renewed?';
        case ContractRenewalStepEnum.ChangesConfirm:
          return 'Are there changes to the current contract?';
        case ContractRenewalStepEnum.QRFAttachmentConfirm:
          return 'Has QRF been created for order management?';
        default:
          return '';
      }
    }
  },

  watch: {
    isDialogActive(value: boolean) {
      // Doing this on close to avoid animation transition when opening
      if (!value) {
        this.goToWizardStep(ContractRenewalStepEnum.RenewalConfirm);
      }
    }
  },

  methods: {
    reject() {
      switch (this.wizardStep) {
        case ContractRenewalStepEnum.RenewalConfirm:
          return this.confirm(ContractRenewalStateEnum.Declined);
        case ContractRenewalStepEnum.ChangesConfirm:
          return this.confirm(ContractRenewalStateEnum.ConfirmedWithoutChanges);
        case ContractRenewalStepEnum.QRFAttachmentConfirm:
          return this.close();
      }
    },

    accept() {
      switch (this.wizardStep) {
        case ContractRenewalStepEnum.RenewalConfirm:
          return this.goToWizardStep(ContractRenewalStepEnum.ChangesConfirm);

        case ContractRenewalStepEnum.ChangesConfirm:
          return this.goToWizardStep(
            ContractRenewalStepEnum.QRFAttachmentConfirm
          );
        case ContractRenewalStepEnum.QRFAttachmentConfirm:
          return this.confirm(ContractRenewalStateEnum.ConfirmedWithChanges);
      }
    },

    goToWizardStep(step: ContractRenewalStepEnum) {
      this.wizardStep = step;
    },

    ...mapActions({
      confirmRenewal: 'contract/confirmRenewal'
    }),

    clearErrors() {
      this.error = null;
    },

    close() {
      // close first dialog in next frame after other dialogs
      this.clearErrors();
      this.$nextTick(() => {
        this.isDialogActive = false;
      });
    },

    renew() {
      this.clearErrors();
      this.isLoading = true;
      this.confirmRenewal({
        contractId: this.contract.id,
        confirmationType: ContractRenewalStateEnum.ConfirmedWithoutChanges
      })
        .then(() => {
          this.close();
          this.createSnack({
            color: 'success darken-1',
            type: 'info',
            right: true,
            msg: 'Contract Renewed',

            timeout: 4000
          });
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    confirm(confirmationType: ContractRenewalStateEnum) {
      this.clearErrors();
      this.isLoading = true;
      this.confirmRenewal({
        contractId: this.contract.id,
        confirmationType: confirmationType
      })
        .then(() => {
          let message =
            'Contract Not Renewed: Recipients notified of rejected renewal';
          if (
            confirmationType === ContractRenewalStateEnum.ConfirmedWithChanges
          ) {
            message = 'Contract Renewed: With changes';
          } else if (
            confirmationType ===
            ContractRenewalStateEnum.ConfirmedWithoutChanges
          ) {
            message = 'Contract Renewed: Without changes';
          }
          this.close();
          this.createSnack({
            color: 'success darken-1',
            type: 'info',
            right: true,
            msg: message,
            timeout: 4000
          });
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    /** Script Hooks for declaring transitions */
    // https://v2.vuejs.org/v2/guide/transitions#JavaScript-Hooks
    beforeEnter(el: HTMLElement) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
    },
    enter(el: HTMLElement, done: () => void) {
      el.offsetHeight; // trigger reflow
      el.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
      done();
    },
    leave(el: HTMLElement, done: () => void) {
      el.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      done();
    }
  }
});
